import { useSelector, shallowEqual } from 'react-redux';

import { useFmrs } from 'hooks/useFmrs';
import { selectMoveInDate } from 'state/move-in-date/move-in-date-slice';

import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';

export const useFmrsPayload = () => {
  const moveInDate = useSelector(selectMoveInDate, shallowEqual);
  const {
    minimumSupplyStartDate,
    billingConsent,
    preferredStartDate
  } = useFmrs();
  const { activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];

  return {
    billingConsent,
    earliestStartDate: isMoveInJourney ? moveInDate : minimumSupplyStartDate,
    customerPreferredStartDate: isMoveInJourney
      ? moveInDate
      : preferredStartDate
  };
};
